/*
 * WYRDO motion helpers (R7 story rebuild — docs/store-theme/REBUILD-PLAN.md §8).
 *
 * One tiny shared layer for the home/PDP motion moments (hero pinball + deal,
 * product-shot ping-in, the boing, carousels). No library: every routine is
 * transforms + opacity driven from ONE requestAnimationFrame ticker that only
 * runs while something has asked for frames. Loaded `defer` on the index and
 * product templates only (layout/theme.liquid).
 *
 * Everything here is a progressive enhancement: the page reads correctly at rest
 * without it, and prefers-reduced-motion is honoured by every consumer.
 */
(function () {
  'use strict';
  if (window.WyrdoMotion) return;

  var mql = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(pointer: fine)');

  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  /* smoothstep — the scrub easing for scroll-linked phases */
  var smooth = function (t) { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); };
  /* back-out overshoot (c1 = 1.70158): the "ping" landing */
  var outBack = function (t) { var c1 = 1.70158, c3 = c1 + 1; t = clamp(t, 0, 1); return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); };
  var outCubic = function (t) { t = clamp(t, 0, 1); return 1 - Math.pow(1 - t, 3); };

  /* ---- the ticker: subscribers get (now, dt seconds). Stops itself when empty. ---- */
  var subs = new Set();
  var raf = 0;
  var last = 0;
  function frame(now) {
    raf = 0;
    var dt = last ? Math.min(0.05, (now - last) / 1000) : 1 / 60;
    last = now;
    subs.forEach(function (fn) { try { fn(now, dt); } catch (e) { console.error(e); subs.delete(fn); } });
    if (subs.size) raf = requestAnimationFrame(frame);
    else last = 0;
  }
  function onFrame(fn) {
    subs.add(fn);
    if (!raf) raf = requestAnimationFrame(frame);
    return function () { subs.delete(fn); };
  }

  /* ---- scroll progress of an element through the viewport ----
     0 when el.top hits `startAt` × vh (from the bottom edge), 1 when it hits `endAt` × vh. */
  function viewProgress(rect, vh, startAt, endAt) {
    var s = vh * startAt, e = vh * endAt;
    return clamp((s - rect.top) / (s - e), 0, 1);
  }

  /* ---- pageshow (bfcache) + theme editor hooks: consumers register a re-sync ---- */
  var resyncs = new Set();
  function onResync(fn) { resyncs.add(fn); return function () { resyncs.delete(fn); }; }
  window.addEventListener('pageshow', function (e) { if (e.persisted) resyncs.forEach(function (fn) { fn(); }); });
  document.addEventListener('shopify:section:load', function () { resyncs.forEach(function (fn) { fn(); }); });
  window.addEventListener('resize', function () {
    clearTimeout(window.__wyrdoResizeT);
    window.__wyrdoResizeT = setTimeout(function () { resyncs.forEach(function (fn) { fn(); }); }, 120);
  }, { passive: true });

  window.WyrdoMotion = {
    get reduce() { return mql.matches; },
    get finePointer() { return fine.matches; },
    clamp: clamp, lerp: lerp, smooth: smooth, outBack: outBack, outCubic: outCubic,
    onFrame: onFrame, onResync: onResync, viewProgress: viewProgress,
  };

  /* ---- the boing: one shared IntersectionObserver for every .wyrdo-boing on the page ---- */
  function wireBoing(root) {
    var els = (root || document).querySelectorAll('.wyrdo-boing:not([data-boing])');
    if (!els.length) return;
    if (mql.matches || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.setAttribute('data-boing', '1'); el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (el) { el.setAttribute('data-boing', '1'); io.observe(el); });
  }
  wireBoing();
  document.addEventListener('shopify:section:load', function (e) { wireBoing(e.target); });
  window.WyrdoMotion.wireBoing = wireBoing;

  /* ---- censor bars: tap to peek (delegated, works on every card everywhere) ---- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('.wyrdo-censor');
    if (!c) return;
    e.preventDefault();
    var shown = c.classList.toggle('is-shown');
    c.setAttribute('aria-pressed', shown ? 'true' : 'false');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var c = e.target.closest && e.target.closest('.wyrdo-censor');
    if (!c) return;
    e.preventDefault(); c.click();
  });
})();
